import { produce } from "immer";
import {
  FETCH_LOCATION_INCIDENT_RECORDS,
  FETCH_LOCATION_INCIDENT_RECORDS_SUCCESS,
  FETCH_LOCATION_INCIDENT_RECORDS_FAILURE,
  FETCH_RESIDENT_INCIDENT_RECORDS,
  FETCH_RESIDENT_INCIDENT_RECORDS_SUCCESS,
  FETCH_RESIDENT_INCIDENT_RECORDS_FAILURE,
  FETCH_INCIDENT_RECORD,
  FETCH_INCIDENT_RECORD_SUCCESS,
  FETCH_INCIDENT_RECORD_FAILURE,
  CREATE_INCIDENT_RECORD,
  CREATE_INCIDENT_RECORD_SUCCESS,
  CREATE_INCIDENT_RECORD_FAILURE,
  UPDATE_INCIDENT_RECORD,
  UPDATE_INCIDENT_RECORD_SUCCESS,
  UPDATE_INCIDENT_RECORD_FAILURE,
  ADD_INCIDENT_NOTIFICATION,
  ADD_INCIDENT_NOTIFICATION_SUCCESS,
  ADD_INCIDENT_NOTIFICATION_FAILURE,
  ESCALATE_INCIDENT_SAFEGUARDING,
  ESCALATE_INCIDENT_SAFEGUARDING_SUCCESS,
  ESCALATE_INCIDENT_SAFEGUARDING_FAILURE,
  CLOSE_INCIDENT_RECORD,
  CLOSE_INCIDENT_RECORD_SUCCESS,
  CLOSE_INCIDENT_RECORD_FAILURE,
  REOPEN_INCIDENT_RECORD,
  REOPEN_INCIDENT_RECORD_SUCCESS,
  REOPEN_INCIDENT_RECORD_FAILURE,
} from "./constants";

export const initialState = {
  locationRegister: {
    counts: {},
    records: [],
    pagination: {},
    loading: false,
  },
  residentRecords: {
    records: [],
    loading: false,
  },
  currentRecord: {
    record: null,
    loading: false,
  },
  isSaving: false,
};

const IncidentRecordReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // Location register
      case FETCH_LOCATION_INCIDENT_RECORDS:
        draft.locationRegister.loading = true;
        break;
      case FETCH_LOCATION_INCIDENT_RECORDS_SUCCESS:
        draft.locationRegister.loading = false;
        draft.locationRegister.counts = action.payload?.counts || {};
        draft.locationRegister.records = action.payload?.records || [];
        draft.locationRegister.pagination = action.payload?.pagination || {};
        break;
      case FETCH_LOCATION_INCIDENT_RECORDS_FAILURE:
        draft.locationRegister.loading = false;
        break;

      // Resident records
      case FETCH_RESIDENT_INCIDENT_RECORDS:
        draft.residentRecords.loading = true;
        break;
      case FETCH_RESIDENT_INCIDENT_RECORDS_SUCCESS:
        draft.residentRecords.loading = false;
        draft.residentRecords.records = action.payload || [];
        break;
      case FETCH_RESIDENT_INCIDENT_RECORDS_FAILURE:
        draft.residentRecords.loading = false;
        break;

      // Get one
      case FETCH_INCIDENT_RECORD:
        draft.currentRecord.loading = true;
        break;
      case FETCH_INCIDENT_RECORD_SUCCESS:
        draft.currentRecord.loading = false;
        draft.currentRecord.record = action.payload;
        break;
      case FETCH_INCIDENT_RECORD_FAILURE:
        draft.currentRecord.loading = false;
        break;

      // Create
      case CREATE_INCIDENT_RECORD:
        draft.isSaving = true;
        break;
      case CREATE_INCIDENT_RECORD_SUCCESS:
        draft.isSaving = false;
        draft.currentRecord.record = action.payload;
        break;
      case CREATE_INCIDENT_RECORD_FAILURE:
        draft.isSaving = false;
        break;

      // Update
      case UPDATE_INCIDENT_RECORD:
        draft.isSaving = true;
        break;
      case UPDATE_INCIDENT_RECORD_SUCCESS:
        draft.isSaving = false;
        draft.currentRecord.record = action.payload;
        break;
      case UPDATE_INCIDENT_RECORD_FAILURE:
        draft.isSaving = false;
        break;

      // Add notification
      case ADD_INCIDENT_NOTIFICATION:
        draft.isSaving = true;
        break;
      case ADD_INCIDENT_NOTIFICATION_SUCCESS:
        draft.isSaving = false;
        draft.currentRecord.record = action.payload;
        break;
      case ADD_INCIDENT_NOTIFICATION_FAILURE:
        draft.isSaving = false;
        break;

      // Escalate to safeguarding
      case ESCALATE_INCIDENT_SAFEGUARDING:
        draft.isSaving = true;
        break;
      case ESCALATE_INCIDENT_SAFEGUARDING_SUCCESS:
        draft.isSaving = false;
        draft.currentRecord.record = action.payload;
        break;
      case ESCALATE_INCIDENT_SAFEGUARDING_FAILURE:
        draft.isSaving = false;
        break;

      // Close
      case CLOSE_INCIDENT_RECORD:
        draft.isSaving = true;
        break;
      case CLOSE_INCIDENT_RECORD_SUCCESS:
        draft.isSaving = false;
        draft.currentRecord.record = action.payload;
        break;
      case CLOSE_INCIDENT_RECORD_FAILURE:
        draft.isSaving = false;
        break;

      // Reopen
      case REOPEN_INCIDENT_RECORD:
        draft.isSaving = true;
        break;
      case REOPEN_INCIDENT_RECORD_SUCCESS:
        draft.isSaving = false;
        draft.currentRecord.record = action.payload;
        break;
      case REOPEN_INCIDENT_RECORD_FAILURE:
        draft.isSaving = false;
        break;

      default:
        return state;
    }
  });

export default IncidentRecordReducer;
